angular.module('cimerFrontEndApp').controller('' +
    'PreviewQuestionModalCtrl', ['$scope', '$uibModalInstance', 'question', function ($scope, $uibModalInstance, question) {
        "use strict";

        $scope.question = question;


        $scope.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }]);